import React from "react";
import graph from "./graph";
import schema from "./schema";
import uiSchema from "./uiSchema";
import LastRequest from "./LastRequest";
import NavigateNextRounded from "@mui/icons-material/NavigateNextRounded";
import {
  Box,
  Grow,
  Stack,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { MuiFormBuilder } from "components";
import { useMutation } from "@apollo/client";

export default function Step02({
  state,
  refetch,
  handleNext,
  handleBack,
  handleState,
}) {
  const { id } = state;
  const { userToken } = useSelector((state) => state.auth);

  const [create, { loading }] = useMutation(graph.create.query);

  const onSubmit = async ({ formData }) => {
    try {
      const {
        title,
        location,
        address,
        tellphone,
        postal_code,
        register_date,
        registered_number,
        national_identifier,
      } = formData;

      const { data, errors } = await create({
        context: {
          serviceName: graph.create.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          id,
          lat: location?.lat,
          lng: location?.lng,
          city: location?.city,
          state: location?.state,

          title,
          address,
          register_date,
          tellphone: tellphone && tellphone,
          postal_code: postal_code && postal_code,
          registered_number: registered_number && registered_number,
          national_identifier: national_identifier && national_identifier,
        },
      });
      if (!errors) {
        refetch();
        handleNext();
      }
    } catch (error) {}
  };

  return (
    <>
      <LastRequest />
      <Stack p={1} flexGrow={1} rowGap={2} overflow="scroll">
        <Typography align="center" variant="caption" color="textDisabled">
          لطفاً مشخصات لابراتوار خود را وارد کنید
        </Typography>
        <Grow in>
          <Box>
            <MuiFormBuilder
              id="submit"
              showSubmit={false}
              liveValidate={false}
              schema={schema()}
              uiSchema={uiSchema()}
              formData={state}
              onSubmit={onSubmit}
            />
          </Box>
        </Grow>
      </Stack>
      <Stack
        p={1}
        py={2}
        columnGap={1}
        alignItems="center"
        direction="row-reverse"
      >
        <Button
          fullWidth
          size="large"
          type="submit"
          form="submit"
          color="primary"
          variant="contained"
          disabled={loading}
        >
          تایید و ادامه
        </Button>
        {/* <IconButton size="medium" color="warning" disabled>
          <NavigateNextRounded />
        </IconButton> */}
      </Stack>
    </>
  );
}
